import React, { useState } from 'react';
import axios from 'axios';

const CableSubscriptionForm = () => {
  const [formData, setFormData] = useState({
    paymentOption: 'Wallet',
    cableTV: '',
    package: '',
    smartCardNo: '',
    phoneNo: '',
    amount: '',
    autoRenew: '0',
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);
    setLoading(true);

    try {
      const response = await axios.post(
        'https://www.nellobytesystems.com/APICableTVV1.asp',
        {
          UserID: 'CK123',
          APIKey: '456',
          CableTV: formData.cableTV,
          Package: formData.package,
          SmartCardNo: formData.smartCardNo,
          PhoneNo: formData.phoneNo,
          CallBackURL: '',
        }
      );

      setMessage(`Transaction Successful: ${response.data}`);
    } catch (error) {
      console.error('Error:', error);
      setMessage('Transaction failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-light2 dark:bg-dark1 text-dark0 dark:text-light1 space-y-6 w-full py-4 px-8 rounded-md">
      <div className="flex flex-col justify-center items-start space-y-2">
        <h2 className="text-primary bg-light1 dark:bg-dark2 px-8 py-1 rounded-2xl">
          TV Subscription
        </h2>
        <hr className="border-dark0 w-full" />
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        {/* TV Subscription */}
        <div>
          <label className="block">TV Subscription:</label>
          <select
            name="cableTV"
            value={formData.cableTV}
            onChange={handleChange}
            className="outline-none border-none dark:bg-dark2 rounded-md h-10 px-2 w-full"
          >
            <option value="">Select TV</option>
            <option value="dstv">DStv</option>
            <option value="gotv">GOtv</option>
            <option value="startimes">StarTimes</option>
          </select>
        </div>

        {/* Package */}
        <div>
          <label className="block">Bouquet/Package:</label>
          <select
            name="package"
            value={formData.package}
            onChange={handleChange}
            className="outline-none border-none dark:bg-dark2 rounded-md h-10 px-2 w-full"
          >
            <option value="">Select Package</option>
            <option value="dstvpadi">DSTV Padi</option>
            <option value="gotvmax">GOtv Max</option>
          </select>
        </div>

        {/* SmartCard/IUC Number */}
        <div>
          <label className="block">SmartCard/IUC Number:</label>
          <input
            type="text"
            name="smartCardNo"
            value={formData.smartCardNo}
            onChange={handleChange}
            className="outline-none border-none dark:bg-dark2 rounded-md h-10 px-2 w-full"
            placeholder="Enter SmartCard/IUC Number"
          />
        </div>

        {/* Phone Number */}
        <div>
          <label className="block">Phone Number:</label>
          <input
            type="text"
            name="phoneNo"
            value={formData.phoneNo}
            onChange={handleChange}
            className="outline-none border-none dark:bg-dark2 rounded-md h-10 px-2 w-full"
            placeholder="Enter Phone Number"
          />
        </div>

        {/* Amount */}
        <div>
          <label className="block">Amount:</label>
          <input
            type="text"
            name="amount"
            value={formData.amount}
            onChange={handleChange}
            className="outline-none border-none dark:bg-dark2 rounded-md h-10 px-2 w-full"
            placeholder="Enter Amount"
          />
        </div>

        {/* Submit Button */}
        <div>
          <button
            type="submit"
            className="btn w-full"
            disabled={loading}
          >
            {loading ? 'Processing...' : 'Pay Now'}
          </button>
        </div>
      </form>

      {message && <p>{message}</p>}
    </div>
  );
};

export default CableSubscriptionForm;
